import axios from "axios";
import { baseUrl } from "../util";

// Flow 41.1a - Materials, Energy, and Water from Use
export const getAllMaterialsEnergyWater41_1aLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/materials-energy-water-41-1a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching materials energy water 41.1a:", error);
      setObjects([]);
    });
};

export const addMaterialsEnergyWater41_1aLCA = ({
  productId,
  process_name,
  describe_use_cycles,
  what_is_added,
  country,
  quantity_per_single_use,
  cycles_per_lifetime,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/materials-energy-water-41-1a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      process_name: process_name || null,
      describe_use_cycles: describe_use_cycles || null,
      what_is_added: what_is_added || null,
      country: country || null,
      quantity_per_single_use: quantity_per_single_use || 0,
      cycles_per_lifetime: cycles_per_lifetime || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding materials energy water 41.1a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateMaterialsEnergyWater41_1aLCA = ({
  productId,
  rowId,
  process_name,
  describe_use_cycles,
  what_is_added,
  country,
  quantity_per_single_use,
  cycles_per_lifetime,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/materials-energy-water-41-1a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      process_name: process_name || null,
      describe_use_cycles: describe_use_cycles || null,
      what_is_added: what_is_added || null,
      country: country || null,
      quantity_per_single_use: quantity_per_single_use || 0,
      cycles_per_lifetime: cycles_per_lifetime || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error updating materials energy water 41.1a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteMaterialsEnergyWater41_1aLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/materials-energy-water-41-1a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting materials energy water 41.1a:", error);
    });
};

// Flow 41.1b - Surplus Resources from Use
export const getAllSurplusResources41_1bLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-41-1b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching surplus resources 41.1b:", error);
      setObjects([]);
    });
};

export const addSurplusResources41_1bLCA = ({
  productId,
  process_name,
  surplus_materials_waste_water,
  quantity_per_single_use,
  cycles_per_lifetime,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-41-1b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      process_name: process_name || null,
      surplus_materials_waste_water: surplus_materials_waste_water || null,
      quantity_per_single_use: quantity_per_single_use || 0,
      cycles_per_lifetime: cycles_per_lifetime || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding surplus resources 41.1b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateSurplusResources41_1bLCA = ({
  productId,
  rowId,
  process_name,
  surplus_materials_waste_water,
  quantity_per_single_use,
  cycles_per_lifetime,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-41-1b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      process_name: process_name || null,
      surplus_materials_waste_water: surplus_materials_waste_water || null,
      quantity_per_single_use: quantity_per_single_use || 0,
      cycles_per_lifetime: cycles_per_lifetime || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error updating surplus resources 41.1b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteSurplusResources41_1bLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-41-1b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting surplus resources 41.1b:", error);
    });
};

// Flow 41.1c - Direct Emissions from Use
export const getAllDirectEmissions41_1cLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/direct-emissions-41-1c-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching direct emissions 41.1c:", error);
      setObjects([]);
    });
};

export const addDirectEmissions41_1cLCA = ({
  productId,
  process_name,
  direct_emission,
  quantity_per_single_use,
  cycles_per_lifetime,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/direct-emissions-41-1c-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      process_name: process_name || null,
      direct_emission: direct_emission || null,
      quantity_per_single_use: quantity_per_single_use || 0,
      cycles_per_lifetime: cycles_per_lifetime || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding direct emissions 41.1c:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateDirectEmissions41_1cLCA = ({
  productId,
  rowId,
  process_name,
  direct_emission,
  quantity_per_single_use,
  cycles_per_lifetime,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/direct-emissions-41-1c-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      process_name: process_name || null,
      direct_emission: direct_emission || null,
      quantity_per_single_use: quantity_per_single_use || 0,
      cycles_per_lifetime: cycles_per_lifetime || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error updating direct emissions 41.1c:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteDirectEmissions41_1cLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/direct-emissions-41-1c-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting direct emissions 41.1c:", error);
    });
};

// Flow 41.2a - Inputs from Maintenance
export const getAllInputsFromMaintenance41_2aLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-maintenance-41-2a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching inputs from maintenance 41.2a:", error);
      setObjects([]);
    });
};

export const addInputsFromMaintenance41_2aLCA = ({
  productId,
  name_maintenance_process,
  describe_maintenance_process,
  describe_maintenance_process_file,
  material_supporting_maintenance,
  quantity_per_fu_material,
  energy_input_during_maintenance,
  quantity_per_fu_energy,
  water_consumption_during_maintenance,
  quantity_per_fu_water,
  maintenance_processes_per_fu_lifetime,
  callback,
  use_swal = false,
}) => {
  const formData = new FormData();
  
  formData.append("name_maintenance_process", name_maintenance_process || null);
  if (describe_maintenance_process_file instanceof File) {
    formData.append("describe_maintenance_process_file", describe_maintenance_process_file);
    formData.append("describe_maintenance_process", null);
  } else {
    formData.append("describe_maintenance_process", describe_maintenance_process || null);
    formData.append("describe_maintenance_process_file", null);
  }
  formData.append("material_supporting_maintenance", material_supporting_maintenance || null);
  formData.append("quantity_per_fu_material", quantity_per_fu_material || 0);
  formData.append("energy_input_during_maintenance", energy_input_during_maintenance || null);
  formData.append("quantity_per_fu_energy", quantity_per_fu_energy || 0);
  formData.append("water_consumption_during_maintenance", water_consumption_during_maintenance || null);
  formData.append("quantity_per_fu_water", quantity_per_fu_water || 0);
  formData.append("maintenance_processes_per_fu_lifetime", maintenance_processes_per_fu_lifetime || 0);

  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-maintenance-41-2a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding inputs from maintenance 41.2a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateInputsFromMaintenance41_2aLCA = ({
  productId,
  rowId,
  name_maintenance_process,
  describe_maintenance_process,
  describe_maintenance_process_file,
  material_supporting_maintenance,
  quantity_per_fu_material,
  energy_input_during_maintenance,
  quantity_per_fu_energy,
  water_consumption_during_maintenance,
  quantity_per_fu_water,
  maintenance_processes_per_fu_lifetime,
  objects,
  setObjects,
  use_swal = false,
}) => {
  const formData = new FormData();
  
  formData.append("name_maintenance_process", name_maintenance_process || null);
  if (describe_maintenance_process_file instanceof File) {
    formData.append("describe_maintenance_process_file", describe_maintenance_process_file);
    formData.append("describe_maintenance_process", null);
  } else {
    formData.append("describe_maintenance_process", describe_maintenance_process || null);
    formData.append("describe_maintenance_process_file", null);
  }
  formData.append("material_supporting_maintenance", material_supporting_maintenance || null);
  formData.append("quantity_per_fu_material", quantity_per_fu_material || 0);
  formData.append("energy_input_during_maintenance", energy_input_during_maintenance || null);
  formData.append("quantity_per_fu_energy", quantity_per_fu_energy || 0);
  formData.append("water_consumption_during_maintenance", water_consumption_during_maintenance || null);
  formData.append("quantity_per_fu_water", quantity_per_fu_water || 0);
  formData.append("maintenance_processes_per_fu_lifetime", maintenance_processes_per_fu_lifetime || 0);

  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-maintenance-41-2a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating inputs from maintenance 41.2a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteInputsFromMaintenance41_2aLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-maintenance-41-2a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting inputs from maintenance 41.2a:", error);
    });
};

// Flow 41.2b - Surplus Resources from Maintenance
export const getAllSurplusResourcesMaintenance41_2bLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-maintenance-41-2b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching surplus resources maintenance 41.2b:", error);
      setObjects([]);
    });
};

export const addSurplusResourcesMaintenance41_2bLCA = ({
  productId,
  name_maintenance_process,
  current_disposal_method,
  quantity_per_fu,
  country_surplus_material_treatment,
  waste_water_during_maintenance,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-maintenance-41-2b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_maintenance_process: name_maintenance_process || null,
      current_disposal_method: current_disposal_method || null,
      quantity_per_fu: quantity_per_fu || 0,
      country_surplus_material_treatment: country_surplus_material_treatment || null,
      waste_water_during_maintenance: waste_water_during_maintenance || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding surplus resources maintenance 41.2b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateSurplusResourcesMaintenance41_2bLCA = ({
  productId,
  rowId,
  name_maintenance_process,
  current_disposal_method,
  quantity_per_fu,
  country_surplus_material_treatment,
  waste_water_during_maintenance,
  objects,
  setObjects,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-maintenance-41-2b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_maintenance_process: name_maintenance_process || null,
      current_disposal_method: current_disposal_method || null,
      quantity_per_fu: quantity_per_fu || 0,
      country_surplus_material_treatment: country_surplus_material_treatment || null,
      waste_water_during_maintenance: waste_water_during_maintenance || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating surplus resources maintenance 41.2b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteSurplusResourcesMaintenance41_2bLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-maintenance-41-2b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting surplus resources maintenance 41.2b:", error);
    });
};

// Flow 41.3a - Inputs from Repair
export const getAllInputsFromRepair41_3aLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-repair-41-3a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching inputs from repair 41.3a:", error);
      setObjects([]);
    });
};

export const addInputsFromRepair41_3aLCA = ({
  productId,
  name_repair_process,
  describe_repair_process,
  describe_repair_process_file,
  material_supporting_repair,
  quantity_per_fu_material,
  energy_input_during_repair,
  quantity_per_fu_energy,
  water_consumption_during_repair,
  quantity_per_fu_water,
  repair_processes_per_fu_lifetime,
  callback,
  use_swal = false,
}) => {
  const formData = new FormData();
  
  formData.append("name_repair_process", name_repair_process || null);
  if (describe_repair_process_file instanceof File) {
    formData.append("describe_repair_process_file", describe_repair_process_file);
    formData.append("describe_repair_process", null);
  } else {
    formData.append("describe_repair_process", describe_repair_process || null);
    formData.append("describe_repair_process_file", null);
  }
  formData.append("material_supporting_repair", material_supporting_repair || null);
  formData.append("quantity_per_fu_material", quantity_per_fu_material || 0);
  formData.append("energy_input_during_repair", energy_input_during_repair || null);
  formData.append("quantity_per_fu_energy", quantity_per_fu_energy || 0);
  formData.append("water_consumption_during_repair", water_consumption_during_repair || null);
  formData.append("quantity_per_fu_water", quantity_per_fu_water || 0);
  formData.append("repair_processes_per_fu_lifetime", repair_processes_per_fu_lifetime || 0);

  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-repair-41-3a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding inputs from repair 41.3a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateInputsFromRepair41_3aLCA = ({
  productId,
  rowId,
  name_repair_process,
  describe_repair_process,
  describe_repair_process_file,
  material_supporting_repair,
  quantity_per_fu_material,
  energy_input_during_repair,
  quantity_per_fu_energy,
  water_consumption_during_repair,
  quantity_per_fu_water,
  repair_processes_per_fu_lifetime,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  const formData = new FormData();
  
  formData.append("name_repair_process", name_repair_process || null);
  if (describe_repair_process_file instanceof File) {
    formData.append("describe_repair_process_file", describe_repair_process_file);
    formData.append("describe_repair_process", null);
  } else {
    formData.append("describe_repair_process", describe_repair_process || null);
    formData.append("describe_repair_process_file", null);
  }
  formData.append("material_supporting_repair", material_supporting_repair || null);
  formData.append("quantity_per_fu_material", quantity_per_fu_material || 0);
  formData.append("energy_input_during_repair", energy_input_during_repair || null);
  formData.append("quantity_per_fu_energy", quantity_per_fu_energy || 0);
  formData.append("water_consumption_during_repair", water_consumption_during_repair || null);
  formData.append("quantity_per_fu_water", quantity_per_fu_water || 0);
  formData.append("repair_processes_per_fu_lifetime", repair_processes_per_fu_lifetime || 0);

  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-repair-41-3a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating inputs from repair 41.3a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteInputsFromRepair41_3aLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-repair-41-3a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting inputs from repair 41.3a:", error);
    });
};

// Flow 41.3b - Surplus Resources from Repair
export const getAllSurplusResourcesRepair41_3bLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-repair-41-3b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching surplus resources repair 41.3b:", error);
      setObjects([]);
    });
};

export const addSurplusResourcesRepair41_3bLCA = ({
  productId,
  name_repair_process,
  current_disposal_method,
  quantity_per_fu,
  country_surplus_material_treatment,
  waste_water_during_repair,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-repair-41-3b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_repair_process: name_repair_process || null,
      current_disposal_method: current_disposal_method || null,
      quantity_per_fu: quantity_per_fu || 0,
      country_surplus_material_treatment: country_surplus_material_treatment || null,
      waste_water_during_repair: waste_water_during_repair || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding surplus resources repair 41.3b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateSurplusResourcesRepair41_3bLCA = ({
  productId,
  rowId,
  name_repair_process,
  current_disposal_method,
  quantity_per_fu,
  country_surplus_material_treatment,
  waste_water_during_repair,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-repair-41-3b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_repair_process: name_repair_process || null,
      current_disposal_method: current_disposal_method || null,
      quantity_per_fu: quantity_per_fu || 0,
      country_surplus_material_treatment: country_surplus_material_treatment || null,
      waste_water_during_repair: waste_water_during_repair || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating surplus resources repair 41.3b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteSurplusResourcesRepair41_3bLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-repair-41-3b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting surplus resources repair 41.3b:", error);
    });
};

// Flow 41.4a - Inputs from Replacement
export const getAllInputsFromReplacement41_4aLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-replacement-41-4a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching inputs from replacement 41.4a:", error);
      setObjects([]);
    });
};

export const addInputsFromReplacement41_4aLCA = ({
  productId,
  name_replacement_process,
  describe_replacement_process,
  describe_replacement_process_file,
  material_supporting_replacement,
  quantity_per_fu_material,
  energy_input_during_replacement,
  quantity_per_fu_energy,
  water_consumption_during_replacement,
  quantity_per_fu_water,
  replacement_processes_per_fu_lifetime,
  callback,
  use_swal = false,
}) => {
  const formData = new FormData();
  
  formData.append("name_replacement_process", name_replacement_process || null);
  if (describe_replacement_process_file instanceof File) {
    formData.append("describe_replacement_process_file", describe_replacement_process_file);
    formData.append("describe_replacement_process", null);
  } else {
    formData.append("describe_replacement_process", describe_replacement_process || null);
    formData.append("describe_replacement_process_file", null);
  }
  formData.append("material_supporting_replacement", material_supporting_replacement || null);
  formData.append("quantity_per_fu_material", quantity_per_fu_material || 0);
  formData.append("energy_input_during_replacement", energy_input_during_replacement || null);
  formData.append("quantity_per_fu_energy", quantity_per_fu_energy || 0);
  formData.append("water_consumption_during_replacement", water_consumption_during_replacement || null);
  formData.append("quantity_per_fu_water", quantity_per_fu_water || 0);
  formData.append("replacement_processes_per_fu_lifetime", replacement_processes_per_fu_lifetime || 0);

  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-replacement-41-4a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding inputs from replacement 41.4a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateInputsFromReplacement41_4aLCA = ({
  productId,
  rowId,
  name_replacement_process,
  describe_replacement_process,
  describe_replacement_process_file,
  material_supporting_replacement,
  quantity_per_fu_material,
  energy_input_during_replacement,
  quantity_per_fu_energy,
  water_consumption_during_replacement,
  quantity_per_fu_water,
  replacement_processes_per_fu_lifetime,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  const formData = new FormData();
  
  formData.append("name_replacement_process", name_replacement_process || null);
  if (describe_replacement_process_file instanceof File) {
    formData.append("describe_replacement_process_file", describe_replacement_process_file);
    formData.append("describe_replacement_process", null);
  } else {
    formData.append("describe_replacement_process", describe_replacement_process || null);
    formData.append("describe_replacement_process_file", null);
  }
  formData.append("material_supporting_replacement", material_supporting_replacement || null);
  formData.append("quantity_per_fu_material", quantity_per_fu_material || 0);
  formData.append("energy_input_during_replacement", energy_input_during_replacement || null);
  formData.append("quantity_per_fu_energy", quantity_per_fu_energy || 0);
  formData.append("water_consumption_during_replacement", water_consumption_during_replacement || null);
  formData.append("quantity_per_fu_water", quantity_per_fu_water || 0);
  formData.append("replacement_processes_per_fu_lifetime", replacement_processes_per_fu_lifetime || 0);

  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-replacement-41-4a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating inputs from replacement 41.4a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteInputsFromReplacement41_4aLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-replacement-41-4a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting inputs from replacement 41.4a:", error);
    });
};

// Flow 41.4b - Surplus Resources from Replacement
export const getAllSurplusResourcesReplacement41_4bLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-replacement-41-4b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching surplus resources replacement 41.4b:", error);
      setObjects([]);
    });
};

export const addSurplusResourcesReplacement41_4bLCA = ({
  productId,
  name_replacement_process,
  current_disposal_method,
  quantity_per_fu,
  country_surplus_material_treatment,
  waste_water_during_replacement,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-replacement-41-4b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_replacement_process: name_replacement_process || null,
      current_disposal_method: current_disposal_method || null,
      quantity_per_fu: quantity_per_fu || 0,
      country_surplus_material_treatment: country_surplus_material_treatment || null,
      waste_water_during_replacement: waste_water_during_replacement || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding surplus resources replacement 41.4b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateSurplusResourcesReplacement41_4bLCA = ({
  productId,
  rowId,
  name_replacement_process,
  current_disposal_method,
  quantity_per_fu,
  country_surplus_material_treatment,
  waste_water_during_replacement,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-replacement-41-4b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_replacement_process: name_replacement_process || null,
      current_disposal_method: current_disposal_method || null,
      quantity_per_fu: quantity_per_fu || 0,
      country_surplus_material_treatment: country_surplus_material_treatment || null,
      waste_water_during_replacement: waste_water_during_replacement || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating surplus resources replacement 41.4b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteSurplusResourcesReplacement41_4bLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-replacement-41-4b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting surplus resources replacement 41.4b:", error);
    });
};

// Flow 41.5a - Inputs from Refurbishment
export const getAllInputsFromRefurbishment41_5aLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-refurbishment-41-5a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching inputs from refurbishment 41.5a:", error);
      setObjects([]);
    });
};

export const addInputsFromRefurbishment41_5aLCA = ({
  productId,
  name_refurbishment_process,
  describe_refurbishment_process,
  describe_refurbishment_process_file,
  material_supporting_refurbishment,
  quantity_per_fu_material,
  energy_input_during_refurbishment,
  quantity_per_fu_energy,
  water_consumption_during_refurbishment,
  quantity_per_fu_water,
  refurbishment_processes_per_fu_lifetime,
  callback,
  use_swal = false,
}) => {
  const formData = new FormData();
  
  formData.append("name_refurbishment_process", name_refurbishment_process || null);
  if (describe_refurbishment_process_file instanceof File) {
    formData.append("describe_refurbishment_process_file", describe_refurbishment_process_file);
    formData.append("describe_refurbishment_process", null);
  } else {
    formData.append("describe_refurbishment_process", describe_refurbishment_process || null);
    formData.append("describe_refurbishment_process_file", null);
  }
  formData.append("material_supporting_refurbishment", material_supporting_refurbishment || null);
  formData.append("quantity_per_fu_material", quantity_per_fu_material || 0);
  formData.append("energy_input_during_refurbishment", energy_input_during_refurbishment || null);
  formData.append("quantity_per_fu_energy", quantity_per_fu_energy || 0);
  formData.append("water_consumption_during_refurbishment", water_consumption_during_refurbishment || null);
  formData.append("quantity_per_fu_water", quantity_per_fu_water || 0);
  formData.append("refurbishment_processes_per_fu_lifetime", refurbishment_processes_per_fu_lifetime || 0);

  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-refurbishment-41-5a-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding inputs from refurbishment 41.5a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateInputsFromRefurbishment41_5aLCA = ({
  productId,
  rowId,
  name_refurbishment_process,
  describe_refurbishment_process,
  describe_refurbishment_process_file,
  material_supporting_refurbishment,
  quantity_per_fu_material,
  energy_input_during_refurbishment,
  quantity_per_fu_energy,
  water_consumption_during_refurbishment,
  quantity_per_fu_water,
  refurbishment_processes_per_fu_lifetime,
  objects,
  setObjects,
  use_swal = false,
}) => {
  const formData = new FormData();
  
  formData.append("name_refurbishment_process", name_refurbishment_process || null);
  if (describe_refurbishment_process_file instanceof File) {
    formData.append("describe_refurbishment_process_file", describe_refurbishment_process_file);
    formData.append("describe_refurbishment_process", null);
  } else {
    formData.append("describe_refurbishment_process", describe_refurbishment_process || null);
    formData.append("describe_refurbishment_process_file", null);
  }
  formData.append("material_supporting_refurbishment", material_supporting_refurbishment || null);
  formData.append("quantity_per_fu_material", quantity_per_fu_material || 0);
  formData.append("energy_input_during_refurbishment", energy_input_during_refurbishment || null);
  formData.append("quantity_per_fu_energy", quantity_per_fu_energy || 0);
  formData.append("water_consumption_during_refurbishment", water_consumption_during_refurbishment || null);
  formData.append("quantity_per_fu_water", quantity_per_fu_water || 0);
  formData.append("refurbishment_processes_per_fu_lifetime", refurbishment_processes_per_fu_lifetime || 0);

  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-refurbishment-41-5a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: formData,
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating inputs from refurbishment 41.5a:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteInputsFromRefurbishment41_5aLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/inputs-from-refurbishment-41-5a-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting inputs from refurbishment 41.5a:", error);
    });
};

// Flow 41.5b - Surplus Resources from Refurbishment
export const getAllSurplusResourcesRefurbishment41_5bLCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-refurbishment-41-5b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching surplus resources refurbishment 41.5b:", error);
      setObjects([]);
    });
};

export const addSurplusResourcesRefurbishment41_5bLCA = ({
  productId,
  name_refurbishment_process,
  current_disposal_method,
  quantity_per_fu,
  country_surplus_material_treatment,
  waste_water_during_refurbishment,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-refurbishment-41-5b-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_refurbishment_process: name_refurbishment_process || null,
      current_disposal_method: current_disposal_method || null,
      quantity_per_fu: quantity_per_fu || 0,
      country_surplus_material_treatment: country_surplus_material_treatment || null,
      waste_water_during_refurbishment: waste_water_during_refurbishment || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding surplus resources refurbishment 41.5b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to add record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const updateSurplusResourcesRefurbishment41_5bLCA = ({
  productId,
  rowId,
  name_refurbishment_process,
  current_disposal_method,
  quantity_per_fu,
  country_surplus_material_treatment,
  waste_water_during_refurbishment,
  objects,
  setObjects,
  use_swal = false,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-refurbishment-41-5b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      name_refurbishment_process: name_refurbishment_process || null,
      current_disposal_method: current_disposal_method || null,
      quantity_per_fu: quantity_per_fu || 0,
      country_surplus_material_treatment: country_surplus_material_treatment || null,
      waste_water_during_refurbishment: waste_water_during_refurbishment || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (setObjects && objects) {
        const updated = objects.map((item) =>
          item.id === rowId ? response.data.data : item
        );
        setObjects(updated);
      }
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
        });
      }
    })
    .catch(function (error) {
      console.error("Error updating surplus resources refurbishment 41.5b:", error);
      if (use_swal) {
        const Swal = require("sweetalert2");
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: error.response?.data?.message || "Failed to update record",
          confirmButtonColor: "#a9c1b4",
        });
      }
    });
};

export const deleteSurplusResourcesRefurbishment41_5bLCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/surplus-resources-refurbishment-41-5b-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting surplus resources refurbishment 41.5b:", error);
    });
};

// Flow 41: Get total impact for full use stage (legacy / other consumers)
export const getUseStage41Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/use-stage-41-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching use stage 41 totals:", error);
      setTotals(null);
    });
};

/** Flow 41.1 only: sums 41.1a + 41.1b + 41.1c (LCA). Same response shape as maintenance-41-2-totals. */
export const getUseStage41_1Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/use-stage-41-1-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching use stage 41.1 totals:", error);
      setTotals(null);
    });
};

// Flow 41.2: Get Total Impact for Maintenance
export const getMaintenance41_2Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/maintenance-41-2-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching maintenance 41.2 totals:", error);
      setTotals(null);
    });
};

/** Flow 41.3 only: sums 41.3a + 41.3b (LCA). Same response shape as use-stage-41-1-totals. */
export const getUseStage41_3Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/use-stage-41-3-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching use stage 41.3 totals:", error);
      setTotals(null);
    });
};

/** Flow 41.4 only: sums 41.4a + 41.4b (LCA). Same response shape as use-stage-41-1-totals. */
export const getUseStage41_4Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/use-stage-41-4-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching use stage 41.4 totals:", error);
      setTotals(null);
    });
};

// Flow 41.5: Get Total Impact for Refurbishment
export const getRefurbishment41_5Totals = ({
  productId,
  setTotals = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/refurbishment-41-5-totals`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotals(response.data.data || null);
    })
    .catch(function (error) {
      console.error("Error fetching refurbishment 41.5 totals:", error);
      setTotals(null);
    });
};

// Flow 41.6 - Losses
export const getAllFlow41_6LCA = ({ productId, setObjects }) => {
  var config = {
    method: "get",
    url: baseUrl + `/api/business/product/${productId}/flow-41-6-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data || []);
    })
    .catch(function (error) {
      console.error("Error fetching flow 41.6:", error);
      setObjects([]);
    });
};

export const addFlow41_6LCA = ({
  productId,
  own_name,
  material,
  amount,
  callback,
  use_swal = false,
}) => {
  var config = {
    method: "post",
    url: baseUrl + `/api/business/product/${productId}/flow-41-6-lca`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      own_name: own_name || null,
      material: material || null,
      amount: amount || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (callback) callback();
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 41.6 item added successfully",
          icon: "success",
          button: "OK",
        });
      }
    })
    .catch(function (error) {
      console.error("Error adding flow 41.6:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to add flow 41.6 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const updateFlow41_6LCA = ({
  productId,
  rowId,
  own_name,
  material,
  amount,
  objects,
  setObjects,
  use_swal = false,
  callback,
}) => {
  var config = {
    method: "put",
    url: baseUrl + `/api/business/product/${productId}/flow-41-6-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      own_name: own_name || null,
      material: material || null,
      amount: amount || 0,
    },
  };

  axios(config)
    .then(function (response) {
      if (use_swal) {
        window.swal({
          title: "Success!",
          text: "Flow 41.6 item updated successfully",
          icon: "success",
          button: "OK",
        });
      }
      if (setObjects && objects) {
        const updatedObjects = objects.map((obj) =>
          obj.id === rowId ? { ...obj, ...response.data.data } : obj
        );
        setObjects(updatedObjects);
      }
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error updating flow 41.6:", error);
      if (use_swal) {
        window.swal({
          title: "Error!",
          text: error.response?.data?.message || "Failed to update flow 41.6 item",
          icon: "error",
          button: "OK",
        });
      }
    });
};

export const deleteFlow41_6LCA = ({ productId, rowId, callback }) => {
  var config = {
    method: "delete",
    url: baseUrl + `/api/business/product/${productId}/flow-41-6-lca/${rowId}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      window.swal({
        title: "Success!",
        text: "Flow 41.6 item deleted successfully",
        icon: "success",
        button: "OK",
      });
      if (callback) callback();
    })
    .catch(function (error) {
      console.error("Error deleting flow 41.6:", error);
      window.swal({
        title: "Error!",
        text: error.response?.data?.message || "Failed to delete flow 41.6 item",
        icon: "error",
        button: "OK",
      });
    });
};


